var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('svg',{attrs:{"id":_vm.id,"width":"500","height":"400"}},[_c('g',{attrs:{"id":"label"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/paywall/dashboard/PieChart.vue